import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { PageHeader } from "@/components/shared/Common";
import { api } from "@/lib/api";

const CHAPTERS = [
  { id: "01-arquitectura", title: "Arquitectura y módulos" },
  { id: "02-datos", title: "Modelo de datos y OT" },
  { id: "03-seguridad-acceso", title: "Usuarios, RBAC y seguridad" },
  { id: "04-auditoria-documental", title: "Auditoría y documentos" },
  { id: "05-operacion", title: "Backups, crons, instalador, PWA" },
  { id: "06-plan", title: "Migraciones, fases y riesgos" },
];

export default function Architecture() {
  const [active, setActive] = useState(CHAPTERS[0].id);
  const [md, setMd] = useState("");
  useEffect(() => { setMd(""); api.get(`/docs/tecnica/${active}`, { responseType: "text" }).then((r) => setMd(r.data)).catch(() => setMd("No tiene permiso para ver esta documentación.")); }, [active]);

  return (
    <div data-testid="architecture-page">
      <PageHeader eyebrow="Documentación · Aprobada" title="Fase 0 — Arquitectura técnica" />
      <div className="flex flex-wrap gap-2 pb-3 mb-4">
        {CHAPTERS.map((c, i) => (
          <button key={c.id} data-testid={`arch-tab-${c.id}`} onClick={() => setActive(c.id)}
            className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${active === c.id ? "bg-[#258F00] border-[#258F00] text-white" : "bg-white border-[#e4e8e1] text-[#5b6656] hover:text-[#17210f]"}`}>
            {String(i + 1).padStart(2, "0")} · {c.title}
          </button>
        ))}
      </div>
      <article className="syc-doc" data-testid="architecture-content">
        {md ? <ReactMarkdown remarkPlugins={[remarkGfm]}>{md}</ReactMarkdown> : "Cargando…"}
      </article>
    </div>
  );
}
